import { useTracking } from 'react-tracking';

import { Modal, Button } from '@simplywallst/ui-core/next';

type Props = {
  onKeepExisting: () => void;
  onStartFresh: () => void;
};

export const DraftState = ({ onKeepExisting, onStartFresh }: Props) => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    subject: 'megaTable',
  });

  return (
    <Track>
      <Modal
        title="Draft portfolio found"
        isOpen
        isDismissable={false}
        className="lg:w-96"
      >
        <Modal.Body>
          You have an existing portfolio in draft that wasn&apos;t saved. Would
          you like to restore it or start fresh?
        </Modal.Body>
        <Modal.Actions>
          <Button
            variant="secondary"
            onClick={() => {
              trackEvent({
                action: 'click',
                subject: 'deleteExistingDraftTransactions',
              });
              onStartFresh();
            }}
          >
            Start fresh
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              trackEvent({
                action: 'click',
                subject: 'keepExistingDraftTransactions',
              });
              onKeepExisting();
            }}
          >
            Keep existing
          </Button>
        </Modal.Actions>
      </Modal>
    </Track>
  );
};
